<template>
  <div class="market-card">
    <header class="card_header">
      <div class="card-pricing">
        <span class="text-white"
          ><img
            :src="getImage(item.price)"
            alt="wax"
            class="img-fluid wax-logo"
          />
          <span class="mx-2 card_price">{{ item.price }}</span>
        </span>
      </div>
      <button class="info_btn" @click="cardInfo(selectedInfo)">
        <i class="bi bi-info"></i>
      </button>
    </header>

    <section class="card-info" v-if="selectedInfo">
      <ul class="p-0">
        <li>
          title <span>{{ item.asset.name }}</span>
        </li>
        <li>
          rarity <span>{{ item.asset.immutable_data.Rarity }}</span>
        </li>
        <li>
          schema <span>{{ item.schema }}</span>
        </li>
        <li>
          template <span>{{ item.asset.template_id }}</span>
        </li>
        <li>
          burnable <span v-if="item.asset.is_burnable == true">Yes</span>
          <span v-else>No</span>
        </li>
        <li>
          Transferable
          <span v-if="item.asset.is_transferable == true">Yes</span>
          <span v-else>No</span>
        </li>
        <!-- <li>Max supply <span>0</span></li> -->
        <!-- <li>Sale <span>80000</span></li> -->
        <li>
          Price <span>{{ item.price }}</span>
        </li>
      </ul>
    </section>

    <section class="card_img text-center" v-else>
      <VideoBlock :link="item.asset_t" />
    </section>

    <section
      class="card-content fw-bold text-center"
      :class="selectedInfo === 'card-info-list' ? 'hideContent' : ''"
    >
      <p>
        Supply {{ item.supply }} /
        {{ Number(item.supply) - Number(item.total_sale) }}
      </p>
    </section>
    <footer class="card_footer mt-3">
      <div class="qty-input">
        <input
          type="number"
          class="form-control"
          placeholder="Quantity"
          v-model="qty"
        />
      </div>
      <button @click="buy(item.asset_t, item.price)" class="btn btn-rounded">
        buy
      </button>
    </footer>
  </div>
</template>
<script>
import ApiService from "../services";
import "vue-loading-overlay/dist/vue-loading.css";
import VideoBlock from "../components/VideoBlock.vue";
export default {
  name: "MarketItem",
  props: ["item"],
  components: {
    VideoBlock,
  },
  data() {
    return {
      selectedInfo: false,
      qty: "",
      openFiltersList: false,
      isLoading: true,
      waxLoaded: false,
      searchTerm: "",
      rarity: "all",
    };
  },
  methods: {
    getImage(price) {
      if (price.includes("WAX")) {
        return "/images/wax-logo.png";
      } else if (price.includes("WWS")) {
        return "/images/scoin.png";
      }
      return "/images/gcoin.png";
    },
    async buy(templateId, price) {
      if (templateId && price && this.qty > 0) {
        let finalPrice = ApiService.calculateCur(price, this.qty);
        let currencyWax = price.includes("WAX");
        let data = ApiService.buyDataMarket(
          currencyWax,
          finalPrice,
          templateId,
          this.qty
        );
        await ApiService.transaction(data, (response) => {
          if (response.processed) {
            ApiService.successMsg("Purchase Successfull");
            this.$emit("refresh", []);
            ApiService.getHeaderContents();
          }
        });
      } else {
        ApiService.errorMsg("Input quantity must be greater than 0");
      }
    },
    cardInfo(selected) {
      this.selectedInfo = !selected;
    },
  },
};
</script>
<style scoped>
.shop-bg .main-content-wrapper .card_img {
  height: 157px !important;
}
.dyn-img{
  width: 106px !important;
}
</style>
